import { render, staticRenderFns } from "./FontSelector.vue?vue&type=template&id=a926f020&scoped=true&"
import script from "./FontSelector.vue?vue&type=script&lang=js&"
export * from "./FontSelector.vue?vue&type=script&lang=js&"
import style0 from "./FontSelector.vue?vue&type=style&index=0&id=a926f020&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a926f020",
  null
  
)

export default component.exports